<template>
    <div class="content-class">
      <div class="wrapper-lightbox" style="max-width: 1020px; max-height: inherit;">
        <div class="lightbox" style="border-radius: 8px; max-height: inherit;">
            <div class="container-logo-stepper">
                <img class="icon-white turn_logo lazyload" style="width: 165px"
                        data-src="/assets/images/layout/AD_Logo/PNG/AutoDeal_Logo_Digital_Cropped.png" alt="AutoDeal">
            </div>
            <form-wizard
                    color="#DBFE54"
                    :title="titleWidzar"
                    :subtitle="subtitleWidzar"
                    nextButtonText="Siguiente"
                    backButtonText="Regresar"
                    errorColor="#DBFE54"
                    @on-complete="onComplete"
                    style="max-height: inherit;"
                    ref="wizard"
                    >
                <tab-content title="¿Qué auto quieres?" :before-change="validateStep">
                <ValidationObserver ref="step1">
                    <span v-show="filters.messageError" class="tx-red-danger" 
                    style="display: flex; justify-content: center; padding-bottom: 5px;">{{ filters.messageError }}</span>
                    <chose-car ref="step1" :filters="filters"></chose-car>
                </ValidationObserver>
                </tab-content>
                <tab-content title="¿Dejas un auto a cuenta?" :before-change="validateStep2">
                <ValidationObserver ref="step2">
                    <data-car-used ref="step2" :filters="filters"></data-car-used>
                </ValidationObserver>
                </tab-content>
                <tab-content title="Datos de contacto" :before-change="validateStep3">
                <ValidationObserver ref="step3">
                    <user-information-contact ref="step3" :filters="filters"></user-information-contact>
                    <div class="container-green-ad">
                        <p style="font-weight: 700; margin: auto; font-style: italic; font-size: 0.9rem;">
                            Te conectamos para que compres el auto nuevo que estás buscando.
                        </p>
                    </div>
                </ValidationObserver>
                </tab-content>
                <button id="finishbtn" ref="finishbtn" class="wizard-btn" slot="finish">
                    Enviar
                </button>
            </form-wizard>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { ValidationObserver } from "vee-validate";
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import VueSweetalert2 from 'vue-sweetalert2';
  // If you don't need the styles, do not connect
  import 'sweetalert2/dist/sweetalert2.min.css';
  
  import UserInformation from './../user_find_car/UserInformation.vue'
  import CarInformation from './../user_find_car/CarInformation.vue';
  import ChoseCar from './ChoseCar.vue';
  import DataCarUsed from './DataCarUsed.vue';
  import UserInformationContact from './UserInformationContact.vue'
  Vue.use(VueSweetalert2);
  
  export default {
    props: ['showModal'],
    components: {
        FormWizard,
        TabContent,
        ValidationObserver,
        UserInformation,
        ChoseCar,
        CarInformation,
        DataCarUsed,
        UserInformationContact,
    },
    data() {
        return {
            filters: {
                searched_car_options: [],
                trade_in: 1,
                trade_in_used_car_info: {
                    brand: null,
                    model: null,
                    year: null,
                    color_id: null,
                    kilometers: null,
                    owners: null
                },
                prospect_name: '',
                prospect_cellphone: '',
                prospect_email: '',
                messageError: ''
            },
            titleWidzar: 'Comprar auto nuevo',
            subtitleWidzar: 'Completa los siguientes pasos para ayudarte a encontrar la mejor opción',
            message: '',
        }
    },
    methods: {
        close () {
            this.$emit('closeModal')
            this.resetForm();
        },
        validateStep() {
            let isValid = (this.filters.searched_car_options.length === 0) ? false : true;
            if (!isValid) {
                this.filters.messageError = "Es necesario agregar los campos requeridos"
                return false;
            }
            this.filters.messageError = ''
            this.titleWidzar = 'Comprar auto nuevo';
            this.subtitleWidzar = 'Completa los siguientes pasos para ayudarte a encontrar la mejor opción';
            return isValid;
        },
        validateStep2 () {
            if (this.filters.trade_in == 0) {
                return true;
            }
            return this.$refs.step2.validate();
        },
        validateStep3 () {
            return this.$refs.step3.validate();
        },
        async onComplete (){
            let vm = this;
            const trade_in = this.filters.trade_in
            let data = null;
            vm.loadingAlert()
            document.getElementById("finishbtn").disabled = true;
            if (trade_in === 0) {
                data = {
                    searched_car_options: vm.filters.searched_car_options,
                    trade_in: vm.filters.trade_in,
                    prospect_name: vm.filters.prospect_name,
                    prospect_cellphone: vm.filters.prospect_cellphone,
                    prospect_email: vm.filters.prospect_email,
                }
            } else {
                vm.filters.trade_in_used_car_info.model = vm.filters.trade_in_used_car_info.model.name
                vm.filters.trade_in_used_car_info.brand = vm.filters.trade_in_used_car_info.brand.name
                data = vm.filters
            }
           await axios.post(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/search-vehicle/brand-new`, data)
            .then((response) => {
                vm.message = response.data.message;
                document.getElementById("finishbtn").disabled = false;
                vm.$swal.close()
                vm.close()
                vm.showSuccessAlert(vm.message)
                vm.resetForm()
                this.$refs.wizard.reset()
            })
            .catch((error) => {
                document.getElementById("finishbtn").disabled = false;
                vm.message = error.response.data.message;
                vm.$swal.close()
                vm.showErrorAlert(vm.message)
            });
        },
        resetForm () {
            this.filters.searched_car_options = [];
            this.filters.trade_in = 1;
            this.filters.trade_in_used_car_info.brand = null
            this.filters.trade_in_used_car_info.model = null
            this.filters.trade_in_used_car_info.year = null
            this.filters.trade_in_used_car_info.color_id = null
            this.filters.trade_in_used_car_info.kilometers = null
            this.filters.trade_in_used_car_info.owners = null
            this.filters.prospect_name = null;
            this.filters.prospect_email = null;
            this.filters.prospect_cellphone = null;
        },
        showErrorAlert(text) {
            // Use sweetalert2
            this.$swal({
                iconHtml: '<img src="../../../../../../assets/images/error_car.png" width="100">',
                title: 'Ha ocurrido un error inesperado.',
                text,
                customClass: {
                icon: 'border-0',
                confirmButton: 'btn-secondary',
                cancelButton: 'btn-outline-primary'
                }
            });
        },
        showSuccessAlert(text) {
            // Use sweetalert2
            let vm = this;
            this.$swal({
                imageUrl: "../../../../../../assets/images/Bangalore.png",
                imageSize: '600x600',
                title: '¡Listo!',
                text: 'Notificamos a las agencias de la marca del auto nuevo que quieres comprar. Serás contactado a través del correo y celular que proporcionaste.',
                customClass: {
                icon: 'border-0',
                confirmButton: 'btn-secondary',
                cancelButton: 'btn-outline-primary'
                }
            }).then((result) => {
                if (result.isConfirmed) {
  
                }
            });
        },
        loadingAlert() {
            this.$swal({
            title: 'Enviando',
            width: '16em',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                this.$swal.showLoading()
            }
            })
        }
    },
  }
  </script>
  <style lang="css" scoped>
    .content-class {
        top: 65px;
        width: 95%;
        left: 2.5%;
        max-height: 1100px;
        position: absolute;
    }
    
    @media screen and (min-width: 1024px) {
        .content-class {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-height: 70%;
        }
    }
    
    .content-class .stepTitle {
        color: black !important;
    }
    .content-class .vue-form-wizard .wizard-title {
        color: #000;
        font-weight: 600;
        margin: 0;
        text-align: center;
        font-size: 1.5rem;
    }
    .content-class .vue-form-wizard .category {
        color: #000;
        font-size: 1rem;
    }
    .content-class .swal2-icon {
        border: none;
    }
    .content-class .swal2-title {
        color: #000;
        font-size: 1.5rem;
        font-weight: 600;
    }
    .content-class .swal2-content {
        color: #000;
        font-size: 1.125rem;
    }
    .content-class .swal2-styled.swal2-confirm {
        background-color: #dcfe54;
        color: #000;
        border: 1px solid #dcfe54;
        font-weight: bold;
    }
    .content-class .vue-form-wizard .wizard-footer-left .wizard-btn{
        color: #000 !important;
        letter-spacing: 2px;
        border-color: black !important;
        background-color: white !important;
        border-width: 0.3px;
    }
    .content-class .vue-form-wizard .wizard-nav-pills>li.active>a .wizard-icon {
        color: #000;
    }
    .content-class .swal2-loader {
        border-color: #000 transparent #000 transparent;
    }
    .content-class .container-logo-stepper {
        display: flex;
        justify-content: center;
        padding-top: 32px;
    }
    .content-class .vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
        top: 26px;
    }
    .content-class .vue-form-wizard .wizard-icon-circle .wizard-icon {
        font-style: normal;
    }
    .content-class .vue-form-wizard.md .wizard-icon-circle {
        width: 40px;
        height: 40px;
        font-size: 20px;
    }
    .content-class .vue-form-wizard .category {
        color: gray !important;
        font-size: 1.1rem !important;
    }
    .content-class .container-green-ad{
        background-color: rgb(219, 254, 84);
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px
    }
  </style>
  